import { action } from 'satcheljs';

export const applyOptions = action('APPLY_ACTIVITY_FEED_OPTIONS');
